import React, { useEffect, useState } from 'react'
import { Card, Container } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate,useParams } from 'react-router-dom'
import useAuth from '../../context/auth/useAuth'
import { getCourseSubjects, getLevels } from '../../actions/miscellaneousActions'
import { getReducedSchoolsByMultiSchool, getSchoolBySelection } from '../../actions/schoolsActions'
import { editProfileTypeSelection,getDescriptionByAI,getSelection } from '../../actions/selectionsActions'
import Swal from 'sweetalert2'
import SelectionForm from '../../components/forms/selections/SelectionForm'
import { getSchoolStaffsBySchool } from '../../actions/schoolStaffActions'

export default function EditSelection() {
    const { t } = useTranslation()
	const {client} = useAuth()
    const navigate = useNavigate()
    const params = useParams()
    const dispatch = useDispatch()

    const {subjects, levels} = useSelector(state => state.miscellaneous)
    const {schools, school, schooluser} = useSelector(state=>state.schools)
    const {selection, resultselection, descriptionByAI, IALoading, loading} = useSelector(state=>state.selections)
    const {schoolStaffs} = useSelector(state=>state.schoolStaffs)

    const [editState, setEditState] = useState(null)

    const [levelSelect, setLevelSelect] = useState()
    const [subjectsSelect, setSubjectsSelect] = useState()

    const handleSelectLinesChange = (level) =>{
        setLevelSelect({...levelSelect, selected: level})
        const subjectsFiltered = subjects?.filter(subject => subject.level === level.value)

        setSubjectsSelect({
            options: subjectsFiltered?.map(subject => {
                return { label: t('subjects.' + subject.label), value: subject.id }
            }) , selected: []})
        setEditState({
            ...editState,
            specialty: level.value,
            subject: null
        })

    }

    const handleSelectSubjectsChange = (subject) =>{
        setSubjectsSelect({...subjectsSelect,selected: subject})
        setEditState({
            ...editState,
            subject: subject.value,
        })
    }

    const verifyLevelSubject = () => {
        if(!editState?.specialty || !editState?.subject){
            Swal.fire({
				showConfirmButton: true,
				icon: 'warning',
				text: t('selection.specialtyerror')
			}).then(() => {
                return false
            })
        }else{
            return true
        }
    }

    const hasWeighting = (requirements, tipo) => {
        let hasContent = false
        for (const key in requirements) {
            const value = requirements[key]
            if (Array.isArray(value)) {
                // Si es un array, verifica los elementos
                for (const item of value) {
                    if (item.weighting === tipo) hasContent = true
                }
            } else if (typeof value === "object" && value !== null) {
                // Si es un objeto (como technologies), revisa sus subpropiedades
                for (const subKey in value) {
                    const subValue = value[subKey]
                    if (tipo === "primary" && subKey === "officeLevel" && subValue !== "none") {
                        hasContent = true
                    }
                    if (Array.isArray(subValue)) {
                        for (const item of subValue) {
                            if (item.weighting === tipo) hasContent = true
                        }
                    }
                }
            }
            if (hasContent) return hasContent
        }
        return hasContent
    }

    const verifyTotalWeight = () => {
        if(!hasWeighting(editState?.requirements, 'primary') && editState?.requirementWeighting?.primary > 0){
            Swal.fire({
				showConfirmButton: true,
				icon: 'warning',
				text: t('selection.requirementserrorprimary')
			})
            return
        }
        if(!hasWeighting(editState?.requirements, 'secondary') && editState?.requirementWeighting?.secondary > 0){
            Swal.fire({
                showConfirmButton: true,
                icon: 'warning',
                text: t('selection.requirementserrorsecondary')
            })
            return
        }
        if(
            parseFloat(editState?.requirementWeighting?.primary || 0) +
            parseFloat(editState?.requirementWeighting?.secondary || 0) +
            parseFloat(editState?.requirementWeighting?.values || 0) !== 100
        ){
            Swal.fire({
				showConfirmButton: true,
				icon: 'warning',
				text: t('selection.requirementserror')
			})
            return false
        }else{
            return true
        }
    }

    const verifySwitch = (object,phrase) => {
        if(object){
            return true
        }else{
            Swal.fire({
				showConfirmButton: true,
				icon: 'warning',
				text: phrase
			}).then(() => {
                return false
            })
        }

    }

    const handleSubmit = (e)=>{
        e.preventDefault()
        let stepFormOk = true
        if (editState.step === 1) {
            if (editState.title && editState.incorporationDate && editState.title.trim() !== "" && editState.incorporationDate.trim() !== "") {
                stepFormOk = true
            } else {
                stepFormOk = false
                Swal.fire({
                    showConfirmButton: true,
                    icon: 'warning',
                    text: t('selection.formError')
                }).then(() => {
                    return false
                })
            }
        }
        if (editState.step === 2) {
            if(verifyLevelSubject()){
                if(verifySwitch(editState?.contractType,t('profile.candidate.contractTypeError'))){
                    if(verifySwitch(editState?.workdayType,t('profile.candidate.idealPosition.workDay.error'))){
                        if(verifyTotalWeight()){
                            stepFormOk = true
                        } else {
                            stepFormOk = false
                        }
                    } else {
                        stepFormOk = false
                    }
                } else {
                    stepFormOk = false
                }
            } else {
                stepFormOk = false
            }
        }
        if (stepFormOk) {
            dispatch(editProfileTypeSelection({...editState, school: editState.school.value},selection._id))
        }
    }

    const generateAIDescription = () => {
        dispatch(getDescriptionByAI(selection._id))
    }

    useEffect(() => {
        if(client){
            if (client.rol === 'MultiSchool'){
                dispatch(getReducedSchoolsByMultiSchool(client?.id))
            }
            dispatch(getSelection(params.id))
            dispatch(getSchoolBySelection(params.id))
            dispatch(getCourseSubjects())
            dispatch(getLevels())
        }
    },[dispatch, t, client, params.id])

    useEffect(() => {
        if(selection){
            let step = 1
            if (selection.interviews && selection.interviews.length > 0) {
                step = 4
            } else if(selection.requirementWeighting?.primary || selection.requirementWeighting?.secondary || selection.requirementWeighting?.values) {
                step = 3
            } else if(selection.incorporationDate) {
                step = 2
            }
            setEditState({
                startDate: selection?.startDate?.substring(0, 10),
                incorporationDate: selection?.incorporationDate.substring(0, 10),
                title: selection?.title,
                profileDescription: selection?.profileDescription,
                ageRange: selection?.ageRange || {min: 18, max: 50},
                subject: selection?.subject,
                specialty: selection?.specialty,
                workdayType: selection?.workdayType,
                bachillerIB: selection?.bachillerIB,
                minimumSalary: selection?.minimumSalary,
                reasonReplacement: selection?.reasonReplacement,
                initReplacement: selection?.initReplacementDate?.substring(0, 10),
                endReplacement: selection?.endReplacementDate?.substring(0,10),
                contractType: selection?.contractType,
                fixedDiscontinuous: selection?.fixedDiscontinuous,
                requirementWeighting: {
                    primary: selection?.requirementWeighting ? selection?.requirementWeighting.primary : 60,
                    secondary: selection?.requirementWeighting ? selection?.requirementWeighting.secondary : 25,
                    values: selection?.requirementWeighting ? selection?.requirementWeighting.values : 15
                },
                videoPresentation: selection?.videoPresentation,
                requirements: {
                    competences: selection?.requirements?.competences,
                    language: selection?.requirements?.language,
                    methodologies: selection?.requirements?.methodologies,
                    technologies: {
                        officeLevel: selection?.requirements?.technologies?.officeLevel,
                        softwares: selection?.requirements?.technologies?.softwares,
                        ecosystems: selection?.requirements?.technologies?.ecosystems,
                        technologyGroups: selection?.requirements?.technologies?.technologyGroups
                    }
                },
                questions: {
                    first: selection?.questions?.first,
                    second: selection?.questions?.second,
                    third: selection?.questions?.third,
                    fourth: selection?.questions?.fourth
                },
                published: selection?.published,
                active: selection?.active,
                started: selection.started,
                publicData: selection.publicData,
                school: {value: selection?.school?._id, label: selection?.school?.name},
                interviews: selection?.interviews,
                deletedInterviews: [],
                step: step,
                showInLandingPage: selection?.showInLandingPage || false
            })
            dispatch(getSchoolStaffsBySchool(selection.school?._id || selection.school))
        }
    },[selection])

    useEffect(() => {
        if (levels) {
            const levelOptions = levels.map(level => ({label: t('levels.' + level.label), value: level.value}))
            let selectedLevel = null
            
            if (editState?.specialty) {
                selectedLevel = levels.find(level => level.value === editState.specialty);
                setLevelSelect({
                    options: levels.map(level => ({label: t('levels.' + level.label), value: level.value})),
                    selected: {label: t('levels.' + selectedLevel.label), value: selectedLevel.value}
                });
                const subjectsFiltered = subjects?.filter(subject => subject.level === editState.specialty);

                setSubjectsSelect({
                    options: subjectsFiltered?.map(subject => {
                        return { label: t('subjects.' + subject.label), value: subject.id }
                    }),
                    selected: editState.subject ? { label: t('subjects.' + subjectsFiltered?.find(subject => subject.id === editState.subject)?.label), value: editState.subject} : {}
                });
            }

            setLevelSelect({
                options: levelOptions,
                selected: selectedLevel
            })
        }
    // eslint-disable-next-line
    }, [levels, subjects, editState?.specialty, editState?.subject]);

    useEffect(() => {
        if(resultselection){
            switch (resultselection) {
                case 'successeditselection':
                    if (editState.published) {
                        Swal.fire({
                            showConfirmButton: true,
                            icon: 'success',
                            text: t('selection.successaddselection')
                        })
                        setEditState(null)
                        if (client.rol === 'MultiSchool'){
                            navigate('/multischool/activeprocesses')
                        } else {
                            navigate('/school/activeprocesses')
                        }
                    } else {
                        if (editState.step < 4) {
                            setEditState({...editState, step: editState.step + 1})
                        }
                    }
                    break;
                    default:
                        Swal.fire({
                        showConfirmButton: true,
                        icon: 'success',
                        text: t('selection.erroraddselection')
                    })
                    break;
            }
            dispatch({type: 'SELECTION_RESET_RESULT'})
        }
    // eslint-disable-next-line
    },[resultselection])

    useEffect(() => {
        if (editState && descriptionByAI) {
            setEditState({...editState, profileDescription: descriptionByAI})
        }
    }, [descriptionByAI])

    return (
        <>
            <Container className='cuerpo'>
                <Card className='mb-5 sombra'>
                    <Card.Body className='px-5 pt-5'>
                        {editState ?
                            <SelectionForm
                                state={editState}
                                setState={setEditState}
                                levelSelect={levelSelect}
                                subjectsSelect={subjectsSelect}
                                handleSelectLinesChange={handleSelectLinesChange}
                                handleSelectSubjectsChange={handleSelectSubjectsChange}
                                submit={handleSubmit}
                                isMultiSchool={client?.rol === 'MultiSchool'}
                                schoolsOptions={schools?.map(school => ({value: school.id, label: school.name})) || []}
                                schoolStaffs={schoolStaffs}
                                school={{school, user: schooluser}}
                                maxScore={selection?.maxScore}
                                generateDescription={generateAIDescription}
                                loading={loading}
                                IALoading={IALoading}
                            />
                        :
                            <></>
                        }
                    </Card.Body>
                </Card>
            </Container>
        </>
    )
}